export const predefinedColors = ['#ef4444','#f97316','#eab308','#22c55e','#3b82f6','#a855f7','#ec4899','#000000','#ffffff'];

export const styles = ['realistic','photographic','illustration','digital art','oil painting','watercolor','anime','cartoon','3D render','sketch','portrait'];

export const modes = ['funny','horror','dark','vibrant','serene','dramatic','surreal','cinematic','dreamy','minimalist'];

export const lightings = ['natural','studio','dramatic','golden hour','backlit','neon','candlelight','sunset','moody','soft','harsh'];

export const colorFilters = ['black & white','sepia','vintage','duotone','cyanotype','high contrast','polaroid'];